import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    thumbnail: {
      height: '100%',
      borderRadius: '4px',
      backgroundSize: 'cover !important',
      marginLeft: 16,
    },
    thumbnailForSvg: {
      height: '100%',
      borderRadius: '4px',
      marginLeft: 16,
    },
    loading: {
      height: '100%',
    },
    photoCardAdd: {
      width: '80%',
      height: '100%',
    },
    icon: {
      height: '100px',
      width: '100px',
      marginBottom: '10px',
    },
    centerContent: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
    },
    deleteButton: {
      marginLeft: '8px',
    },
    markerArea: {
      marginTop: '16px',
    },
    activeButton: {
      backgroundColor: MaterialPalette.primary.main,
      borderRadius: '100%',
      marginBottom: 50,
    },
    toolbox: {
      display: 'none',
    },
    deleteFile: {
      width: '100%',
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: '0.15px',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    trashIcon: {
      height: 40,
      width: 40,
      lineHeight: '53px',
      background: 'black',
      borderRadius: '100px',
      textAlign: 'center',
    },
    editIcon: {
      height: 40,
      width: 40,
      lineHeight: '50px',
      background: 'black',
      borderRadius: '100px',
      textAlign: 'center',
      marginRight: 8,
    },
    imgGrid: {
      width: '100%',
      height: '100%',
      alignSelf: 'center',
    },
    div1: {
      float: 'right',
      margin: 8,
    },
    div2: {
      display: 'flex',
      flexDirection: 'row',
    },
    deletebuttonGrid: {
      padding: 5,
    },
    dialogGrid: {
      padding: '25px 0px 25px 0px',
    },
  }),
);

export default useStyles;
export { useStyles };
